// extracted by mini-css-extract-plugin
export default {"creatableOption":"_e58e421a","borderTop":"_f8c42895","absolutePlaceholder":"_45d14a26"};